import {useEffect,useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {selectShowUpdateModal,setShowUpdateModal} from './slice'
import {envAwarePost} from '../../../util/util'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import useStripeAccount from '../../../hooks/useStripeAccount'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import BillingUpdateForm from './BillingUpdateForm'

const UpdateBillingModal = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(selectShowUpdateModal)
	const handleClose = ()=>{
		dispatch(setShowUpdateModal(false))
	}
	
	const user = useSelector( 
		state => state.users.current_user
	)

	const stripePromise = useStripeAccount(
		user?.trainer_stripe_account
	)

	const getSetupIntent = () => envAwarePost(
		'api/user/api/',
		{action:'getSetupIntent'}
	)

	const [clientSecret,setClientSecret] = useState(null)
	
	useEffect( async ()=>{
		if (user.account_type==='client') {
			const res = await getSetupIntent()
			console.log(res)
			setClientSecret(res.data.setup_intent.client_secret)
		}
	},[])

	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>
					Update Billing Info
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{(Boolean(stripePromise)&&Boolean(clientSecret))&&
					<Elements stripe={stripePromise} options={{clientSecret}}>
						<ElementsConsumer>
							{({ elements, stripe }) => (
								<BillingUpdateForm
									elements={elements}
									stripe={stripe}
								/>
							)}
						</ElementsConsumer>
					</Elements>
				}
				{!(Boolean(stripePromise)&&Boolean(clientSecret))&&
					<div className="p-3 text-center">
						<Spinner animation="border"/>
					</div>
				}
			</Modal.Body>
		</Modal>
	)
}

export default UpdateBillingModal